"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _queryString = require("query-string");

var _methods = _interopRequireDefault(require("./methods"));

var _HttpClientError = _interopRequireDefault(require("./HttpClientError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FetchClient = /*#__PURE__*/function () {
  function FetchClient(_ref) {
    var baseUrl = _ref.baseUrl,
        headers = _ref.headers,
        config = _objectWithoutProperties(_ref, ["baseUrl", "headers"]);

    _classCallCheck(this, FetchClient);

    _defineProperty(this, "options", void 0);

    if (!baseUrl) {
      throw Error("You must provide baseUrl");
    }

    var mergedHeaders = _objectSpread({}, headers, {
      accept: "application/json",
      "content-type": "application/json"
    });

    this.options = _objectSpread({}, config, {
      baseUrl: baseUrl,
      headers: mergedHeaders
    });
  }

  _createClass(FetchClient, [{
    key: "_handleResponse",
    value: function _handleResponse(res, requestOptions) {
      return res.json().then(function (jsonResult) {
        if (!res.ok) {
          if (process.env.NODE_ENV === "development") {
            // eslint-disable-next-line
            console.warn("Request with parameters", requestOptions, "has been failed with status", res.status, "and response", jsonResult);
          }

          var error = jsonResult.error;

          if (typeof error === "string") {
            error = {
              message: error,
              statusCode: res.status,
              errorAction: "",
              errorCode: "",
              errorObj: null,
              errorType: null
            };
          }

          if (!error.statusCode) {
            error.statusCode = res.status;
          }

          throw new _HttpClientError["default"](error);
        }

        return jsonResult;
      });
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (_ref2) {
      var _this = this;

      var method = _ref2.method,
          path = _ref2.path,
          query = _ref2.query,
          headers = _ref2.headers,
          body = _ref2.body,
          _ref2$options = _ref2.options,
          options = _ref2$options === void 0 ? {} : _ref2$options;

      var _this$options = this.options,
          baseUrl = _this$options.baseUrl,
          defaultHeaders = _this$options.headers,
          defaultOptions = _objectWithoutProperties(_this$options, ["baseUrl", "headers"]);

      var url = "".concat(baseUrl).concat(path);

      var requestOptions = _objectSpread({
        method: method
      }, defaultOptions, {
        headers: _objectSpread({}, defaultHeaders, {}, headers)
      }, options);

      if (query) {
        // $FlowFixMe
        var castedQuery = query;
        url = "".concat(url, "?").concat((0, _queryString.stringify)(castedQuery));
      }

      if (body) {
        requestOptions.body = JSON.stringify(body);
      }

      return fetch(url, requestOptions).then(function (res) {
        return _this._handleResponse(res, requestOptions);
      });
    })
  }, {
    key: "get",
    value: function get(params) {
      if (typeof params === "string") {
        params = {
          path: params
        };
      }

      return this.fetch(_objectSpread({}, params, {
        method: _methods["default"].GET
      }));
    }
  }, {
    key: "post",
    value: function post(params) {
      return this.fetch(_objectSpread({}, params, {
        method: _methods["default"].POST
      }));
    }
  }, {
    key: "put",
    value: function put(params) {
      return this.fetch(_objectSpread({}, params, {
        method: _methods["default"].PUT
      }));
    }
  }, {
    key: "delete",
    value: function _delete(params) {
      return this.fetch(_objectSpread({}, params, {
        method: _methods["default"].DELETE
      }));
    }
  }]);

  return FetchClient;
}();

var _default = FetchClient;
exports["default"] = _default;